import { columnDisplayName } from '../../../../../ui/features/badge-management/components/BadgeAccountsSelectionPanel/types';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { useDataTablePagination } from '../../../../../ui/hooks/useDataTablePagination';
import { removeAccountTableGlobalConfigActions } from '../../../../../ui/util/removeAccountTableGlobalConfigActions';
import { DataTable, useDataTableUsingState } from '@juvare/common-data-table-ui/DataTable';
import { FiltersBar } from '@juvare/common-data-table-ui/FiltersBar';
import { useAccountsTable } from '@juvare/contact-management/ui/features/accounts';
import { useAccountFilterConfig } from '@juvare/contact-management/ui/features/accounts/hooks/useAccountsFilterConfig';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Button, IconButton, Toolbar } from '@mui/material';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
export const AccountsSelectTableDialog = (props) => {
    var _a;
    const { t } = useBadgingTranslation();
    const settings = useSelector(getSettings);
    const [selectedAccounts, setSelectedAccounts] = useState((_a = props.selectedAccounts) !== null && _a !== void 0 ? _a : []);
    const selectedAccountIds = selectedAccounts.map((row) => row.id);
    const getAccountsSelectedAfterSelectionChanged = (accountsCurrent, accountSelectionChanged, selected) => {
        const accountsWithoutSelected = accountsCurrent.filter((a) => a.id !== accountSelectionChanged.id);
        return selected ? [...accountsWithoutSelected, props.mapToSelectedAccount(accountSelectionChanged)] : accountsWithoutSelected;
    };
    const handleSingleSelectionChanged = (row, selected) => {
        setSelectedAccounts((prevAccounts) => getAccountsSelectedAfterSelectionChanged(prevAccounts, row, selected));
    };
    const handleMultiSelectionChanged = (rows, selected) => {
        setSelectedAccounts((prevAccounts) => rows.reduce((accs, row) => getAccountsSelectedAfterSelectionChanged(accs, row, selected), prevAccounts));
    };
    const handleClose = () => {
        props.onClose(undefined, true);
    };
    const handleSave = () => {
        props.onSaveAccountSelection(selectedAccounts);
        props.onClose();
    };
    const columnsDefault = [
        {
            headerLabel: t('badges.create.wizard.step3.accountSelection.selectionTableColumnName'),
            cellFunction: (row) => React.createElement(Typography, { sx: { wordWrap: 'break-word' } }, row.columns.displayName),
            sortKey: columnDisplayName,
        },
        {
            headerLabel: t('badges.create.wizard.step3.accountSelection.selectionTableColumnRole'),
            cellFunction: (row) => row.columns.systemRole in settings.systemRoleMap ? settings.systemRoleMap[row.columns.systemRole].label : 'Unknown',
        },
    ];
    const columns = props.renderColumns ? props.renderColumns(columnsDefault) : columnsDefault;
    const { dataTableProps, filtersBarProps } = useAccountsTable({
        initialSelectedRowIds: selectedAccountIds,
        staticStorageClientFilter: props.initialStorageClientFilter,
        useDataTableFunction: useDataTableUsingState,
        rowSelectionEnabled: true,
        showAccountsIManage: true,
        showAccountSystemRoleFilter: 'quickFilter',
    });
    const filterConfig = useAccountFilterConfig({
        advancedSearchItems: [],
        showAccountSystemRoleFilter: 'quickFilter',
        extendFilters: props.accountTableExtendFilters,
    });
    const dataTablePropsAdjusted = removeAccountTableGlobalConfigActions(Object.assign(Object.assign({}, dataTableProps), { rows: dataTableProps.rows }));
    const pagination = useDataTablePagination({
        rows: dataTablePropsAdjusted.rows,
        totalRowCount: dataTablePropsAdjusted.rows.length,
        defaultRowsPerPage: 8,
        rowsPerPageOptions: [8, 10, 20, 50],
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(AppBar, { sx: { position: 'relative', maxHeight: 64 } },
            React.createElement(Toolbar, null,
                React.createElement(IconButton, { edge: 'start', color: 'inherit', "aria-label": 'Close', onClick: handleClose },
                    React.createElement(CloseIcon, null)),
                React.createElement(Typography, { variant: 'h6', sx: { flexGrow: 1 } }, t('badges.create.wizard.step3.accountSelection.selectionDialogTitle')),
                React.createElement(Button, { color: 'inherit', onClick: handleSave }, t('badges.create.wizard.step3.accountSelection.selectionDialogActionSave')))),
        React.createElement(DataTable, Object.assign({}, dataTablePropsAdjusted, pagination, { filtersBar: React.createElement(FiltersBar, Object.assign({}, filtersBarProps, { config: filterConfig })), title: '', selectedRowIds: selectedAccountIds, onRowSelectionChange: handleSingleSelectionChanged, onSelectAllRowsInCurrentPageClick: handleMultiSelectionChanged, columns: columns }))));
};
